import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { ModalHeader } from './ModalHeader';
import { ModalTitle } from './ModalTitle';
import { ModalBody } from './ModalBody';
import { ModalFooter } from './ModalFooter';

export interface IModalProps {
  show: boolean;
  className?: string;
  onClose(): void;
}

export class Modal extends React.Component<IModalProps> {
  public static Header: (props: any) => JSX.Element;
  public static Title: (props: any) => JSX.Element;
  public static Body: (props: any) => JSX.Element;
  public static Footer: (props: any) => JSX.Element;
  constructor(props: any) {
    super(props);
  }

  render() {
    const className = `modal-container ${this.props.className || ''}`;

    return this.props.show
      && ReactDOM.createPortal(
        (
          <div className={className} onClick={this.props.onClose}>
            <div id="modal" onClick={e => e.stopPropagation()}>
              {this.props.children}
            </div>
          </div>
        ),
        document.body);
  }
}

Modal.Header = ModalHeader;
Modal.Title = ModalTitle;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.tsx